import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_ConfidentialityComplianceAgrmt = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_ConfidentialityComplianceAgrmt' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>CONFIDENTIALITY/COMPLIANCE AGREEMENT</h3></p>
                <p className='w-750'>
                    I, &nbsp;
                    <input type='text' id='txtName' name='txtName' className='add-only w-150 custom-add-only' />
                    ,
                    do hereby acknowledge in the signing of this written statement, to observe, follow, and abide by any 
                    and all rules and regulations, especially those governing/concerning confidentiality of all documents 
                    including, but not limited to client's rights, client's roles and objectives, behavioral plans, medical 
                    charts, procedural mannual, behavior managment and any and all aspects of day to day living/support in the facilities.
                </p>
                
                <p className='w-750'><hr /></p>

                <p className='w-750'>
                    I fully understand that this agreement is binding and must be adhered to in all aspecats and that the 
                    breaching of any part of this confidentiality statement can carry legal implications.
                </p>
                
                <p className='w-750'><hr /></p>

                <p className='w-750'>
                    I acknowledge my understanding and willingness to comply with this request by affixing my signature below.
                </p>


            </div>
        </form >

    )
}











